<script lang="ts" setup>
	import CheckIcon from './CheckIcon.vue'

	interface Props {
		selected?: boolean
		showCheckIcon?: boolean
	}

	withDefaults(defineProps<Props>(), {
		selected: false,
		showCheckIcon: true,
	})

	const emit = defineEmits<{
		select: []
	}>()
</script>

<template>
	<div
		:class="[
			'relative border-2 rounded-lg p-3 lg:p-4 cursor-pointer transition-all duration-300',
			selected ?
				'border-[#021F58] bg-[#021F58]/5'
			:	'border-gray-200 hover:border-[#021F58]/30',
		]"
		@click="emit('select')"
	>
		<slot />

		<!-- Check icon positioned at top-right -->
		<div
			v-if="selected && showCheckIcon"
			class="absolute -top-2 -right-2"
		>
			<CheckIcon
				size="md"
				color="blue"
			/>
		</div>
	</div>
</template>
